import { IonLabel } from '@ionic/react';
import moment from 'moment';
import React, { useRef, useState, RefObject, FormEvent } from 'react';
import './style.scss';
interface DateInputProps {
  onChange: (...event: any[]) => void;
  onBlur: () => void;
  value: any;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  labelClassname?: string;
  isColumnLayout?: boolean;
  isISOFormat?: boolean;
}

type Part = 'day' | 'month' | 'year';

const DateInput: React.FC<DateInputProps> = ({
  onChange,
  value,
  name,
  disabled,
  className = '',
  labelClassname = '',
  isColumnLayout = false,
  isISOFormat = false
}) => {
  const monthInputRef = useRef<HTMLInputElement>(null);
  const yearInputRef = useRef<HTMLInputElement>(null);
  let splittedValue, defaultDay, defaultMonth, defaultYear;
  if (value instanceof Date) {
    const date = moment(value);
    defaultDay = date.format('DD');
    defaultMonth = date.format('MM');
    defaultYear = value.getFullYear();
  } else {
    splittedValue = value ? value.split('/') : [];
    defaultDay = splittedValue[0];
    defaultMonth = splittedValue[1];
    defaultYear = splittedValue[2];
  }
  const [day, setDay] = useState(defaultDay ? defaultDay : '');
  const [month, setMonth] = useState(defaultMonth ? defaultMonth : '');
  const [year, setYear] = useState(defaultYear ? defaultYear : '');
  const getFormattedValue = (v: string, part: Part) => {
    switch (part) {
      case 'day':
        return `${v}/${month}/${year}`;
      case 'month':
        return `${day}/${v}/${year}`;
      case 'year':
        return `${day}/${month}/${v}`;
    }
  };
  const getInputCallback = (
    inputRef: RefObject<HTMLInputElement> | null,
    setter: typeof setDay,
    part: Part
  ) => {
    return (e: FormEvent) => {
      let value = (e.target as HTMLInputElement).value;
      if (value.length >= 2) {
        if (inputRef) {
          inputRef.current?.focus();
        }
      }
      setter(value);
      let formattedValue = getFormattedValue(value, part);

      if (isISOFormat) {
        formattedValue = moment(formattedValue, 'DD/MM/YYYY').toISOString();
      }
      onChange(formattedValue);
    };
  };

  const type = 'number';
  return (
    <div
      className={`date-input ${isColumnLayout ? 'is-column' : ''} ${
        labelClassname ? 'has-label-class' : ''
      }`}
    >
      <div className="">
        <IonLabel className={labelClassname}>Jour</IonLabel>
        <input
          name={name}
          type={type}
          value={day}
          placeholder="JJ"
          onInput={getInputCallback(monthInputRef, setDay, 'day')}
          onChange={(e) => {
            let value = (e.target as HTMLInputElement).value;
            setDay(value);
          }}
          disabled={disabled}
          className={`${className} custom-input`}
        />
      </div>
      <div className="">
        <IonLabel className={labelClassname}>Mois</IonLabel>
        <input
          name={name}
          type={type}
          value={month}
          onInput={getInputCallback(yearInputRef, setMonth, 'month')}
          onChange={(e) => {
            let value = (e.target as HTMLInputElement).value;
            setMonth(value);
          }}
          placeholder="MM"
          ref={monthInputRef}
          disabled={disabled}
          className={`${className} custom-input`}
        />
      </div>
      <div className="">
        <IonLabel className={labelClassname}>Année</IonLabel>
        <input
          name={name}
          type={type}
          value={year}
          onChange={(e) => {
            let value = (e.target as HTMLInputElement).value;
            setYear(value);
          }}
          onInput={getInputCallback(null, setYear, 'year')}
          placeholder="AAAA"
          ref={yearInputRef}
          disabled={disabled}
          className={`${className} custom-input`}
        />
      </div>
    </div>
  );
};

export default DateInput;
